export class RevisedFieldModel {
	failed: ComparerResponseModel[];
	otherChanges: ComparerResponseModel[];

	constructor() {
		this.failed = [];
		this.otherChanges = [];
	}
}

export class ComparerResponseModel {
	path: string;
	historical: HistoricalDataItemMode[];
	medatata: any;
	value: any;
}

export class HistoricalDataItemMode {
	val: string;
	created: string;
	documentId: string;
}
